/* eslint-disable sort-keys-fix/sort-keys-fix */
export const CountriesFR = Object.fromEntries(
  Object.entries({
    AF: 'Afghanistan',
    AX: `îles d'Åland`,
    AL: 'Albanie',
    DZ: 'Algérie',
    AS: 'Samoa américaines',
    AD: 'Andorre',
    AO: 'Angola',
    IA: 'Anguilla',
    AQ: 'Antarctique',
    AG: 'Antigua-et-Barbuda',
    AR: 'Argentine',
    AM: 'Arménie',
    AW: 'Aruba',
    AU: 'Australie',
    AT: 'Autriche',
    AZ: 'Azerbaïdjan',
    BS: 'Bahamas',
    BH: 'Bahreïn',
    BD: 'Bangladesh',
    BB: 'Barbade',
    BY: 'Biélorussie',
    BE: 'Belgique',
    BZ: 'Bélize',
    BJ: 'Bénin',
    BM: 'Bermudes',
    BT: 'Bhoutan',
    BO: 'Bolivie',
    BA: 'Bosnie-Herzégovine',
    NB: 'Botswana',
    BV: 'Ile Bouvet',
    BR: 'Brésil',
    IO: "Territoire britannique de l'océan Indien",
    VG: 'Îles Vierges britanniques',
    BN: 'Brunei',
    BG: 'Bulgarie',
    BF: 'Burkina Faso',
    BI: 'Burundi',
    KH: 'Cambodge',
    CM: 'Cameroun',
    CA: 'Canada',
    CV: 'Cap-Vert',
    BQ: 'Pays-Bas des Caraïbes',
    KY: 'Îles Caïmans',
    CF: 'République centrafricaine',
    TD: 'Tchad',
    CL: 'Chili',
    CN: 'Chine',
    CX: `L'île Noël`,
    CC: 'Îles Cocos (Keeling)',
    CO: 'Colombie',
    KM: 'Comores',
    CG: 'Congo - Brazzaville',
    CD: 'Congo-Kinshasa',
    CK: 'Îles Cook',
    CR: 'Costa Rica',
    CI: `Côte d'Ivoire`,
    RH: 'Croatie',
    UC: 'Cuba',
    CW: 'Curaçao',
    CY: 'Chypre',
    CZ: 'Tchéquie',
    DK: 'Danemark',
    DJ: 'Djibouti',
    DM: 'Dominique',
    DO: 'République dominicaine',
    CE: 'Équateur',
    EX: 'Égypte',
    SV: 'Salvador',
    GQ: 'Guinée équatoriale',
    ER: 'Erythrée',
    EE: 'Estonie',
    SZ: 'Eswatini',
    ET: 'Éthiopie',
    FK: 'Îles Falkland',
    FO: 'Îles Féroé',
    FJ: 'Fidji',
    FI: 'Finlande',
    FR: 'France',
    GF: 'Guyane française',
    PF: 'Polynésie française',
    TF: 'Terres Australes Françaises',
    GA: 'Gabon',
    GM: 'Gambie',
    GE: 'Géorgie',
    DE: 'Allemagne',
    GH: 'Ghana',
    GI: 'Gibraltar',
    GR: 'Grèce',
    GL: 'Groenland',
    GD: 'Grenade',
    GP: 'Guadeloupe',
    GU: 'Guam',
    GT: 'Guatemala',
    GG: 'Guernesey',
    GN: 'Guinée',
    GW: 'Guinée-Bissau',
    GY: 'Guyane',
    HT: 'Haïti',
    HM: 'Îles Heard & McDonald',
    HN: 'Honduras',
    HK: 'Hong Kong RAS Chine',
    HU: 'Hongrie',
    IS: 'Islande',
    IN: 'Inde',
    ID: 'Indonésie',
    RI: 'Iran',
    QI: 'Irak',
    IE: 'Irlande',
    IM: 'Île de Man',
    IL: 'Israël',
    IT: 'Italie',
    JM: 'Jamaïque',
    JP: 'Japon',
    JE: 'Jersey',
    JO: 'Jordanie',
    KZ: 'Kazakhstan',
    KE: 'Kenya',
    KI: 'Kiribati',
    KW: 'Koweït',
    KG: 'Kirghizistan',
    LA: 'Laos',
    LV: 'Lettonie',
    LB: 'Liban',
    LS: 'Lesotho',
    LR: 'Libéria',
    LY: 'Libye',
    LI: 'Liechtenstein',
    LT: 'Lituanie',
    LU: 'Luxembourgeois',
    MO: 'Macao RAS Chine',
    MG: 'Madagascar',
    MW: 'Malawi',
    MY: 'Malaisie',
    MV: 'Maldives',
    ML: 'Mali',
    MT: 'Malte',
    MH: 'Îles Marshall',
    MQ: 'Martinique',
    MR: 'Mauritanie',
    MU: 'Maurice',
    YT: 'Mayotte',
    MX: 'Mexique',
    FM: 'Micronésie',
    MD: 'Moldavie',
    MC: 'Monaco',
    MN: 'Mongolie',
    ME: 'Monténégro',
    MS: 'Montserrat',
    MA: 'Maroc',
    MZ: 'Mozambique',
    MM: 'Myanmar (Birmanie)',
    NA: 'Namibie',
    NR: 'Nauru',
    NP: 'Népal',
    NL: 'Pays-Bas',
    NC: 'Nouvelle-Calédonie',
    NZ: 'Nouvelle-Zélande',
    NI: 'Nicaragua',
    NE: 'Niger',
    NG: 'Nigéria',
    NU: 'Niué',
    NF: 'Île Norfolk',
    KP: 'Corée du Nord',
    MK: 'Macédoine du Nord',
    MP: 'Îles Mariannes du Nord',
    NO: 'Norvège',
    OM: 'Oman',
    PK: 'Pakistan',
    PW: 'Palaos',
    PS: 'Territoires palestiniens',
    AP: 'Panama',
    PG: 'Papouasie-Nouvelle-Guinée',
    PY: 'Paraguay',
    PE: 'Pérou',
    PH: 'Philippines',
    PN: 'Îles Pitcairn',
    PL: 'Pologne',
    PT: 'Portugal',
    RP: 'Porto Rico',
    QA: 'Qatar',
    RE: 'Réunion',
    RO: 'Roumanie',
    RU: 'Russie',
    RW: 'Rwanda',
    WS: 'Samoa',
    SM: 'Saint-Marin',
    ST: 'São Tomé & Príncipe',
    SA: 'Arabie Saoudite',
    SN: 'Sénégal',
    RS: 'Serbie',
    SC: 'Seychelles',
    SL: 'Sierra Leone',
    SG: 'Singapour',
    SX: 'Saint-Martin',
    SK: 'Slovaquie',
    SI: 'Slovénie',
    SB: 'Îles Salomon',
    SO: 'Somalie',
    ZA: 'Afrique du Sud',
    GS: 'Géorgie du Sud et îles Sandwich du Sud',
    KR: 'Corée du Sud',
    SS: 'Soudan du Sud',
    ES: 'Espagne',
    LK: 'Sri Lanka',
    BL: 'St. Barthélemy',
    SH: 'St. Hélène',
    KN: 'St. Saint-Kitts-et-Nevis',
    LC: 'St. Lucie',
    MF: 'St. Martin',
    PM: 'St. Pierre & Miquelon',
    VC: 'St. Vincent & Grenadines',
    SD: 'Soudan',
    SR: 'Surinam',
    SJ: 'Svalbard & Jan Mayen',
    SE: 'Suède',
    CH: 'Suisse',
    SY: 'Syrie',
    TW: 'Taïwan',
    TJ: 'Tadjikistan',
    TZ: 'Tanzanie',
    TH: 'Thaïlande',
    TL: 'Timor-Oriental',
    TG: 'Togo',
    TK: 'Tokélaou',
    TO: 'Tonga',
    TT: 'Trinité-et-Tobago',
    TN: 'Tunisie',
    TR: 'Turquie',
    TM: 'Turkménistan',
    TC: 'Îles Turques et Caïques',
    TV: 'Tuvalu',
    UM: 'États-Unis. Îles éloignées',
    VI: 'U.S. Les iles vierges',
    UG: 'Ouganda',
    UA: 'Ukraine',
    AE: 'Emirats Arabes Unis',
    GB: 'Royaume-Uni',
    US: 'États-Unis',
    UY: 'Uruguay',
    UZ: 'Ouzbékistan',
    VU: 'Vanuatu',
    VA: 'Cité du Vatican',
    VE: 'Venezuela',
    VN: 'Vietnam',
    WF: 'Wallis & Futuna',
    EH: 'Sahara Occidental',
    YE: 'Yémen',
    ZM: 'Zambie',
    ZW: 'Zimbabwe',
  }).sort(),
)
